import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { handleUnauthorized } from "../../utils/apiHelper";
import SuccessAlert from "./../child/Alert/SuccessAlert";
import DengerAlert from "./../child/Alert/DengerAlert";
import Loader from "./../child/Loder";

const SettingLayer = () => {
  const [loading, setLoading] = useState(false);
  const [settings, setSettings] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchSetting = async () => {
      setLoading(true);
      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/settingList`;

      try {
        const response = await fetch(API_ENDPOINT, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        const data = await response.json();

        if (response.status === 401) {
          handleUnauthorized(navigate);
          return;
        }

        if (response.ok) {
          setSettings(Array.isArray(data.settings) ? data.settings : []);
        } else {
          setErrorMessage("Error fetching settings");
          setTimeout(() => setErrorMessage(""), 3000);
        }
      } catch (error) {
        setErrorMessage("Error fetching settings");
        setTimeout(() => setErrorMessage(""), 3000);
      } finally {
        setLoading(false);
      }
    };

    fetchSetting();
  }, [navigate]);
  const validateInputs = () => {
    const newErrors = {};
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const websiteRegex =
      /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/\S*)?$/;
    const numberRegex = /^[0-9]+(\.[0-9]+)?$/;

    settings.forEach((setting) => {
      const key = setting.key;
      const value = setting.value.trim();

      // Required validation for all fields
      if (!value) {
        newErrors[key] = `${setting.labelName} is required`;
        return;
      }

      // Email validation
      if (key === "email" && !emailRegex.test(value)) {
        newErrors[key] = "Please enter a valid email address";
      }

      // Website URL validation
      if (key === "website_url") {
        const trimmedValue = value.trim();

        // Check for spaces or repeated domains in the string
        const urlMatches = trimmedValue.match(
          /(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}/g
        );

        if (!websiteRegex.test(trimmedValue)) {
          newErrors[key] = "Please enter a valid website URL";
        } else if (urlMatches && urlMatches.length > 1) {
          newErrors[key] = "Please enter a valid website URL";
        }
      }

      // Number validations
      if (key === "contactus" && !/^\+1 \d{3}-\d{3}-\d{4}$/.test(value)) {
        newErrors[key] =
          "Please enter a valid phone number in +1 123-456-7890 format";
      }

      // if (["contact_us"].includes(key) &&
      //   !numberRegex.test(value)
      // ) {
      //   newErrors[key] = `Please enter a valid ${setting.labelName}`;
      // }

      // Custom required fields
      if (["help"].includes(key) && value.length === 0) {
        newErrors[key] = `${setting.labelName} is required`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent form reload

    if (!validateInputs()) return;
    event.preventDefault();
    setLoading(true);
    try {
      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/settingMultiUpdate`;
      const payload = settings.map(({ _id, key, value }) => ({
        _id,
        key,
        value,
      }));

      const response = await fetch(API_ENDPOINT, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setSuccessMessage("Settings saved successfully");
        setTimeout(() => {
          setSuccessMessage("");
          navigate("/settings");
        }, 1000);
      } else {
        setErrorMessage("Error saving settings");
        setTimeout(() => setErrorMessage(""), 3000);
      }
    } catch (error) {
      setErrorMessage("Error saving settings");
      setTimeout(() => setErrorMessage(""), 3000);
    } finally {
      setLoading(false);
    }
  };
  const handleInputChange = (key, value) => {
    setSettings((prevSettings) =>
      prevSettings.map((setting) =>
        setting.key === key ? { ...setting, value: value.trimStart() } : setting
      )
    );

    // Remove validation error when user starts typing
    setErrors((prevErrors) => ({ ...prevErrors, [key]: "" }));
  };

  if (loading) {
    if (loading) return <Loader />;
  }

  return (
    <div className="row gy-4">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-header">
            {/* <h5 className="card-title mb-0">Settings</h5> */}
          </div>
          <div className="card-body">
            {successMessage && <SuccessAlert message={successMessage} />}
            {errorMessage && <DengerAlert message={errorMessage} />}
            <form
              className="row gy-3 needs-validation"
              noValidate
              onSubmit={handleSubmit}
            >
              {settings.map(
                (setting, index) =>
                  setting.isShow && (
                    <div className="col-md-12" key={setting._id || index}>
                      <label className="form-label">
                        {setting.labelName}
                        <span className="text-danger-600">*</span>
                      </label>
                      {setting.type === "text" && (
                        <>
                          {setting.key === "contactus" ? (
                            <input
                              type="text"
                              className="form-control"
                              id={setting.key}
                              placeholder="+1 xxx-xxx-xxxx"
                              maxLength="17"
                              value={setting.value || ""}
                              onChange={(e) => {
                                let input = e.target.value.replace(/\D/g, ""); // remove non-digits

                                // Don't format anything if input is empty
                                if (input.length === 0) {
                                  handleInputChange(setting.key, "");
                                  return;
                                }

                                // Avoid duplicate 1s (remove if user types starting with 1)
                                if (input.startsWith("1"))
                                  input = input.slice(1);

                                input = input.slice(0, 10); // max 10 digits

                                let formatted = "+1";
                                if (input.length > 0)
                                  formatted += " " + input.slice(0, 3);
                                if (input.length >= 4)
                                  formatted += "-" + input.slice(3, 6);
                                if (input.length >= 7)
                                  formatted += "-" + input.slice(6, 10);

                                handleInputChange(setting.key, formatted);
                              }}
                            />
                          ) : (
                            <input
                              type="text"
                              className="form-control"
                              id={setting.key}
                              placeholder={setting.labelName}
                              maxLength="64"
                              value={setting.value}
                              onChange={(e) =>
                                handleInputChange(setting.key, e.target.value)
                              }
                              onInput={(e) => {
                                e.target.value = e.target.value
                                  .replace(/\s{2,}/g, " ") // Replace multiple spaces with a single space
                                  .trimStart(); // Prevent leading spaces
                              }}
                            />
                          )}
                          {errors[setting.key] && (
                            <small className="text-danger">
                              {errors[setting.key]}
                            </small>
                          )}
                        </>
                      )}
                      {setting.type === "textarea" && (
                        <>
                          <textarea
                            id={setting.key}
                            className="form-control"
                            placeholder={setting.labelName}
                            value={setting.value}
                            onChange={(e) =>
                              handleInputChange(setting.key, e.target.value)
                            }
                            onInput={(e) => {
                              e.target.value = e.target.value
                                .replace(/\s{2,}/g, " ") // Replace multiple spaces with a single space
                                .trimStart(); // Prevent leading spaces
                            }}
                          />
                          {errors[setting.key] && (
                            <small className="text-danger">
                              {errors[setting.key]}
                            </small>
                          )}
                        </>
                      )}
                    </div>
                  )
              )}

              <div className="col-12">
                <button
                  className="btn btn-primary"
                  type="submit"
                  style={{ float: "inline-end", marginTop: "10px !important" }}
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingLayer;
